export const PriceChartType = {
  purchasePrices: 0,
  sellingPrices: 1,
};
